import { useEffect } from 'react';

import { trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2.ts';

export const useTrackItemSearchSimilarItemsTest = (): void => {
    useEffect(() => {
        trackAbTestV2Variant('PDP_SimilarityEndpointTest1_March2026');
    }, []);
};
